import { Provider } from "jotai";
import { useEffect, useRef, useState } from "react";
import AddCommentForm from "../CommentList/AddCommentForm/AddCommentForm";
import { CommentCreatedBy } from "../CommentList/common/CommentCreatedBy/CommentCreatedBy";
import CommentNameView from "../CommentList/common/CommentNameView/CommentNameView";
import Compteur from "./Compteur";
import TitreZone from "./TitreZone";

// Commentaires : le dernier commentaire (auteur, date, texte sur deux lignes)
// et un ajout rapide replié sur une ligne. L'éditeur (mentions @) n'est monté
// qu'à l'ouverture : la liste n'en porte plus un par carte.
const ZoneCommentaires = ({ commentaires = [], contacts = [], onAjouter, ouvrir }) => {
  const [ouvert, setOuvert] = useState(false);
  const [rendreFocus, setRendreFocus] = useState(false);
  const refOuvrir = useRef(null);
  const dernier = commentaires[commentaires.length - 1];

  // Le bouton d'ouverture n'est pas dans la page tant que l'éditeur est
  // ouvert : le focus lui revient une fois l'éditeur refermé.
  useEffect(() => {
    if (ouvert || !rendreFocus) return;
    if (refOuvrir.current) refOuvrir.current.focus();
    setRendreFocus(false);
  }, [ouvert, rendreFocus]);

  const ajouter = (comment) => {
    if (!comment || !String(comment.text || "").trim()) return;
    onAjouter(comment);
    setOuvert(false);
  };

  const annuler = () => {
    setOuvert(false);
    setRendreFocus(true);
  };

  return (
    <section className="la-zone" aria-label="Commentaires">
      <TitreZone icone="fa-comment-alt" onglet="commentaires" ouvrir={ouvrir}>
        Commentaires <Compteur plein={commentaires.length > 0}>{commentaires.length}</Compteur>
      </TitreZone>
      {dernier ? (
        <div className="la-dernier-com">
          <CommentCreatedBy comment={dernier} />
          <div className="la-dernier-com__texte">
            <CommentNameView comment={dernier} />
          </div>
        </div>
      ) : (
        <p className="la-aucun">Aucun commentaire.</p>
      )}
      {ouvert ? (
        <div className="la-composer">
          <Provider>
            <AddCommentForm addComment={ajouter} users={contacts} onCancel={annuler} autoFocus compact />
          </Provider>
        </div>
      ) : (
        <button ref={refOuvrir} type="button" className="la-composer__ouvrir" onClick={() => setOuvert(true)}>
          <i className="fa fa-comment-dots" aria-hidden="true" />
          Ajouter un commentaire…
        </button>
      )}
    </section>
  );
};

export default ZoneCommentaires;
